import { ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import BaseEntitiesSearchAutocomplete, {
  BaseEntitiesSearchAutocompleteInheritableProps,
} from "@/common/components/Entity/components/BaseEntitiesSearchAutocomplete";
import AppIcon from "@/common/components/Icons/AppIcon";
import { apiClient } from "@/core/api/ApiClient";
import { VehicleModelDto, VehicleModelGetPaginatedDto } from "@/core/api/generated/v1";

import { vehicleModelToOption } from "./VehicleModelAutocomplete";

export interface VehicleModelsAutocompleteProps extends BaseEntitiesSearchAutocompleteInheritableProps<VehicleModelDto> {
  searchFilters?: Partial<Omit<VehicleModelGetPaginatedDto, "search" | "includeIds">>;
}

export default function VehicleModelsAutocomplete({
  searchFilters,
  isPreload = true,
  ...otherProps
}: VehicleModelsAutocompleteProps) {
  return (
    <BaseEntitiesSearchAutocomplete
      sx={{ minWidth: 200 }}
      entityToOption={vehicleModelToOption}
      isPreload={isPreload}
      request={{
        requestFunc: apiClient.vehicleModelsApi.apiV1ReferenceDataVehiclesModelsGetPost,
        limit: 25,
        parameters: {
          vehicleModelGetPaginatedDto: {
            ...searchFilters,
          },
        },
        combineParameters: (params, newParams) => ({
          ...params,
          vehicleModelSearchPaginatedDto: {
            ...params.vehicleModelGetPaginatedDto,
            ...newParams,
          },
        }),
        deps: [searchFilters],
      }}
      label='Models'
      placeholder='Search for models...'
      renderOption={(props, option) => {
        return (
          <ListItem {...props} key={option.id}>
            <ListItemIcon>
              <AppIcon of='vehicle' />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography component='div' variant='body1'>
                  {option.title}
                </Typography>
              }
            />
          </ListItem>
        );
      }}
      {...otherProps}
    />
  );
}
